import { useState, useEffect } from "react";
import React from "react";
import { toast } from 'react-toastify';
import { useNavigate, useParams } from "react-router-dom";
import Pagination from '@mui/material/Pagination';
import Header from '../shared/components/Header'
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";
import { fetchAlbaranes } from "../../../../redux/albaranes";
import { ALBARANES_API } from "../shared/services/albaranes";
import ActionsMenu from "../shared/components/ActionsMenu";
import { getActions } from "./actions";
import ConfirmModal from "../shared/components/ConfirmModal";
import { setErrorMessage } from "../shared/helpers/functionalities";

export default function Albaranes() {
  const dispatch = useDispatch();
  const { page } = useParams();
  const currPage = parseInt(page);
  let navigate = useNavigate();
  const [currentAlbaran, setCurrentAlbaran] = useState(null);
  const [openConfirmSend, setOpenConfirmSend] = useState(false);
  const [currentPage, setPage] = useState(currPage);
  const tipoFacturas = useSelector(state => state.tipo_facturas );
  const albaranes = useSelector(state => state.albaranes);
  const searcher = useSelector(state => state.search)

  useEffect(() => {
    dispatch(fetchAlbaranes(currPage, getQuery()));
  }, [searcher]);

  const getQuery = () => {
    const isEmpty = Object.values(searcher).every(x => x === null || x === '');
    let query = !isEmpty ? '&search=' + (searcher?.search ? searcher?.search : '')
    : null;

    return query;
  }

  const handleSearch = (searchData) => {
    setPage(1);
    navigate(`/albaranes/${1}`);
    dispatch({type: "search/set", payload: searchData});     
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    navigate(`/albaranes/${newPage}`);
    dispatch(fetchAlbaranes(newPage, getQuery()));
  }

  const getPaginationCount = () => {
    var totalPages = albaranes?.total_items < 15 ? 1 : Math.ceil(albaranes?.total_items / 15);
    return totalPages ? parseInt(totalPages) : 0;
  }

  const handleAction = (action, albaran) => {
    if(action === 'download') {
      generateThePdf(albaran)
    } else  if(action === 'regenerate') {
      regenerate(albaran)
    } else if(action === 'sendByEmail') {
      handleOpenConfirmSend(albaran);
    }
  }

  const generateThePdf = async (albaran) => {
      dispatch({type: 'loading/set', payload: true});
      const pdfResult = await ALBARANES_API.download(albaran.id);

      if(pdfResult) {
        window.open(pdfResult.data, "_blank");
      } else {
        toast.error('Ups! Algo ha ido mal...')
      }
      dispatch({type: 'loading/set', payload: false});
  }

  const regenerate = async(albaran) => {
    dispatch({type: 'loading/set', payload: true});
    const response = await ALBARANES_API.regenerate({albaran_id: albaran.id});

    if(response && response.success) {
      dispatch({type: 'loading/set', payload: false});
      toast.success(response.message);
    }
  }

  const getTipoFacturaName = (tipoClienteId) => tipoFacturas.find(tp => tp.id === tipoClienteId)?.nombre;

  const handleView = (item) => { 
    localStorage.removeItem('searcher');

    if(item === 'facturas') {
      navigate('/facturas/1', { replace: true });
    } else {
      navigate('/notas-cargo/1', { replace: true });
    }
  }

  const getSubtotal = (albaran) => {
    return parseFloat(albaran.subtotal).toFixed(2);
  }

  const getTotalIVA = (albaran, conDescuento) => {
    let totalIVA;

    if(conDescuento) {
      totalIVA = albaran.total_iva;
    } else {
      totalIVA = albaran.total_iva + albaran.total_descuento_iva
    }
    
    return parseFloat(totalIVA).toFixed(2);
  }

  const handleOpenConfirmSend = (factura) => {
    setCurrentAlbaran(factura);
    setOpenConfirmSend(true);
  }
  const handleCloseConfirmSend = () => {
    setOpenConfirmSend(false);
    setCurrentAlbaran(null);
  }

  const handleSendAlbaranByEmail = async(confirm) => {
    if(confirm) {
      dispatch({type: 'loading/set', payload: true});
      const response = await ALBARANES_API.sendByEmail(currentAlbaran.id)
      .catch(function (error) {
        dispatch({type: 'loading/set', payload: false});
        toast.error(setErrorMessage(error))
      });

      if(response && response.success) {
        dispatch({type: 'loading/set', payload: false});
        toast.success(response.message);
      }
    }

    handleCloseConfirmSend();
  }

  return (
    <div className="content pt-3">
      <Header viewSearch={true} onSearch={handleSearch}></Header>

      <div className="w-100 d-flex flex-column align-items-end content-table">
        <div className="d-flex align-items-center mb-3">
          <button className="btn btn-default me-3" onClick={() => handleView('notas')}>Notas de cargo</button>
          <button className="btn btn-default me-3" onClick={() => handleView('facturas')}>Facturas</button>
        </div>

        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Nº</th>
                <th className="text-center">tipo</th>
                <th className="text-center">fecha</th>
                <th className="text-center">venta</th>
                <th className="text-center">devolucion</th>
                <th className="text-center">total</th>
                <th className="text-center">total envío</th>
                <th className="text-center">total casco</th>
                <th className="text-center">subtotal</th>
                <th className="text-center">I.V.A</th>
                <th className="text-center">total I.V.A</th>
                <th className="text-center">descuento</th>
                <th className="text-center">total I.V.A</th>
                <th className="text-center"></th>
              </tr>
            </thead>

            <tbody>
              { albaranes.albaranes?.map((albaran) => {
                return (
                  <tr key={albaran.id}>
                    <td>{albaran.numero}</td>
                    <td className="text-center text-uppercase">{tipoFacturas?.length > 0 ? getTipoFacturaName(albaran.tipo_factura_id) : ''}</td>
                    <td className="text-center">{moment(albaran.fecha).format("DD-MM-YYYY")}</td>
                    <td className="text-center">{albaran.venta_id}</td>
                    <td className="text-center">{albaran.devolucion_id !== null ? albaran.devolucion_id : ''}</td>
                    <td className="text-center">{parseFloat(albaran.total).toFixed(2)}€</td>
                    <td className="text-center">{parseFloat(albaran.total_envio).toFixed(2)}€</td>
                    <td className="text-center">{parseFloat(albaran.total_casco).toFixed(2)}€</td>
                    <td className="text-center">{getSubtotal(albaran)}€</td>
                    <td className="text-center">{albaran.iva}%</td>
                    <td className="text-center">{getTotalIVA(albaran, false)}€</td>
                    <td className="text-center">
                      { (albaran.vale_descuento) ?
                        <div className="d-flex flex-column">
                          { (albaran.tipo_factura_id === 2 || albaran.tipo_factura_id === 3) ? 
                              +parseFloat(albaran.total_descuento_iva > 0 ? albaran.total_descuento_iva : albaran.total_descuento).toFixed(2) + '€'
                              : 
                              -parseFloat(albaran.total_descuento_iva > 0 ? albaran.total_descuento_iva : albaran.total_descuento).toFixed(2) + '€'
                          }
                          <span className="fw-bold text-green">{albaran?.vale_descuento.codigo}</span>
                        </div>
                        : '-'
                      }
                    </td>
                    <td className="text-center">{getTotalIVA(albaran, true)}€</td>
                    <td className="text-center">
                      <ActionsMenu 
                          options={getActions()}
                          onAction={(action) => handleAction(action, albaran)}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <Pagination 
          className="mt-3" 
          count={getPaginationCount()} 
          page={currentPage} 
          onChange={handleChangePage} 
        />
      </div>

      { openConfirmSend && 
        <ConfirmModal 
            onConfirmAction={handleSendAlbaranByEmail} 
            title={'Enviar albarán ' + currentAlbaran.numero} 
            description={'Estás seguro de enviarlo por email?'}
            state={openConfirmSend}>
        </ConfirmModal>
      }
    </div>
  )
}